export default __webpack_public_path__ + "static/media/megane-rs-gallery-9.d17ea2a6.jpg";